import { upsertDerivedColumns } from '../../../../data/analyticsDataSlice';
import { TpDerivedColumnPatch, TpValueType } from '../../../../data/interfaces';
import { validateLedgerActionAgainstPatches } from '../../../../data/mutation-ledger/helpers';
import type { LedgerAction } from '../../../../data/mutation-ledger/schemas';
import { TpDashboardActionContext } from '../interfaces';

// Pure: builds a single derived-column patch, without touching Redux. Reused by all action steps that
// add/update a single column, and by dbActionStepTypeTableJoin.ts's own multi-column dispatch.
export function buildDerivedColumnPatch(
  tableId: string,
  columnId: string,
  columnName: string,
  columnDescription: string | null,
  columnValType: TpValueType,
  columnGroupId: string | null,
  columnGroupName: string | null,
  columnGroupDescription: string | null,
  columnData: any[],
  columnDecimalDigits: number | null = null,
): TpDerivedColumnPatch {
  return {
    tableId,
    columnId,
    columnName,
    columnDescription,
    valueType: columnValType,
    decimalDigits: columnDecimalDigits,
    groupId: columnGroupId,
    groupName: columnGroupName,
    groupDescription: columnGroupDescription,
    columnData,
  };
}

export function addTableColumn(
  ctx: TpDashboardActionContext,
  tableId: string,
  columnId: string,
  columnName: string,
  columnDescription: string | null,
  columnValType: TpValueType,
  columnGroupId: string | null,
  columnGroupName: string | null,
  columnGroupDescription: string | null,
  columnData: any[],
  columnDecimalDigits: number | null = null,
  ledgerAction?: LedgerAction,
) {
  const patches = [
    buildDerivedColumnPatch(
      tableId,
      columnId,
      columnName,
      columnDescription,
      columnValType,
      columnGroupId,
      columnGroupName,
      columnGroupDescription,
      columnData,
      columnDecimalDigits,
    ),
  ];
  if (ledgerAction) validateLedgerActionAgainstPatches(ledgerAction, patches);

  ctx.dispatch(
    upsertDerivedColumns({
      dataContextId: ctx.dataContext.id,
      patches,
      ledgerAction,
    }),
  );
}
